var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "notif-panel" }, [
    _c("div", { staticClass: "notif-panel-header" }, [
      _c("span", { staticClass: "notif-panel-title" }, [
        _vm._v("Notifications"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "notif-panel-actions" }, [
        _vm.unreadCount > 0
          ? _c(
              "button",
              {
                staticClass: "notif-mark-all-btn",
                on: { click: _vm.markAllRead },
              },
              [_vm._v("\n                Mark all read\n            ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "notif-close-btn",
            attrs: { title: "Close" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_c("fa", { attrs: { icon: ["fas", "times"] } })],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "notif-list" },
      [
        _vm.loading
          ? _c("div", { staticClass: "notif-empty" }, [
              _c("span", {
                staticClass: "spinner-border spinner-border-sm text-secondary",
                attrs: { role: "status" },
              }),
            ])
          : _vm.notifications.length > 0
          ? _c(
              "transition-group",
              { attrs: { name: "notif", tag: "div" } },
              _vm._l(_vm.notifications, function (n) {
                return _c(
                  "div",
                  {
                    key: n.id,
                    staticClass: "notif-item",
                    class: { "notif-item--unread": !n.read },
                    on: {
                      click: function ($event) {
                        return _vm.markRead(n)
                      },
                    },
                  },
                  [
                    !n.read
                      ? _c("span", { staticClass: "notif-unread-dot" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "notif-body" }, [
                      _c("p", { staticClass: "notif-message" }, [
                        _vm._v(_vm._s(n.msg)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "notif-time" }, [
                        _vm._v(
                          _vm._s(_vm.formatDate(n.timestamp)) +
                            " - " +
                            _vm._s(_vm.formatTime(n.timestamp))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "notif-delete-btn",
                        attrs: { title: "Delete" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.deleteNotification(n)
                          },
                        },
                      },
                      [_c("fa", { attrs: { icon: ["fas", "trash"] } })],
                      1
                    ),
                  ]
                )
              }),
              0
            )
          : _c("div", { staticClass: "notif-empty" }, [
              _vm._v("No notifications"),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }